import styled from 'styled-components';

import { MobileScreen } from '../../../../shared/components/styles/ConstantMediaQuery';
import ColorConstants from '../../../../shared/constants/ColorConstants';

export const EconomySavingsMessage = styled.h4`
    align-items: center;
    color: ${ColorConstants.white};
    display: flex;
    font-size: 15px;
    justify-content: center;
    
    @media screen and (max-width: 1200px) {
        font-size: 14px;
    }

    @media ${MobileScreen} {
        font-size: 14px;
        white-space: nowrap;
    }
`;
